module.exports = __webpack_public_path__ + "static/media/certificate-badge.2c518fe4.svg";